import React from 'react';

import { SVGComponentProps } from './svg.types';

const BugSVG = ({ fill = 'currentColor', size = '1em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.888916" width="20" height="20" rx="6" fill="#E8584E" />
      <path
        d="M12.8889 9C12.8889 7.89543 11.9935 7 10.8889 7C9.78435 7 8.88892 7.89543 8.88892 9V12C8.88892 13.1046 9.78435 14 10.8889 14C11.9935 14 12.8889 13.1046 12.8889 12V9Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3889 7.5L12.8889 8.5"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.38892 7.5L8.88892 8.5"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3889 13.5L12.8889 12.5"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.38892 13.5L8.88892 12.5"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14.8889 10.5H12.8889" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.88892 10.5H8.88892" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.88892 6L10.3889 7" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.8889 6L11.3889 7" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default BugSVG;
